module.exports = __webpack_public_path__ + "img/planetGalaxy.5f15779a.webp";